'use strict';

/**
 * Класс транспорта агента.
 * Предоставляет инструменты для получения и работы с доступным транспортом Веб-агента, например с NPAPI- или HTTP-транспортом.
 *
 * @class transport
 * @since 5.0.0.4100
 */
(function (global) {
  var transport = {
    httpReady: $.Deferred(),

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает доступный транспорт для Веб-агента.
     * Доступные виды транспорта: HTTP-транспорт.
     *
     * @method transport#getTransport
     * @returns {AgentCore.transport.BaseTransport} Объект типа BaseTransport.
     * @since 5.1.0.1500
     */
    getTransport: function () {
      return global.agentCore.transport.HTTP;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Запускает Веб-агент.
     *
     * @method transport#start
     * @param {string} sessionId ID сессии пользователя.
     * @returns {Object} Отложенный (deferred) объект.
     * @since 5.1.0.1500
     */
    start: function (sessionId) {
      global.agentCore.log.info('AGENT: Starting agent transport');
      return this.getTransport().start(sessionId);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Ожидает запуск Веб-агента.
     *
     * @method transport#waitForStart
     * @param {string} [sessionId] ID сессии пользователя.
     * @param {number} [timeout] таймаут.
     * @param {function} callbackWhenNotRegistered Функция, вызываемая если регистрация сессии отклонена агентом.
     * @returns {Object} Отложенный (deferred) объект.
     * @since 5.1.0.1500
     */
    waitForStart: function (sessionId, timeout, callbackWhenNotRegistered) {
      return this.getTransport().waitForStart(sessionId, timeout, callbackWhenNotRegistered);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    cancelStart: function () {
      this.getTransport().cancelStart();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    stop: function () {
      this.getTransport().stop();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Ожидает запуск Веб-агента.
     *
     * @method transport#start
     * @param {string} sessionId ID сессии пользователя.
     * @returns {Object} Отложенный (deferred) объект.
     * @since 5.1.0.1500
     */
    restart: function (sessionId) {
      return this.getTransport().restart(sessionId);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Обновить порты агента.
     *
     * @method transport#updateWorkingPorts
     * @param {string} httpPort Http порт агента.
     * @param {string} httpsPort Https порт агента.
     * @return {transport} Объект типа транспорт агента.
     */
    updateWorkingPorts: function(httpPort, httpsPort) {
      this.getTransport().updateWorkingPorts(httpPort, httpsPort);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отправляет запрос Агенту веб-доступа, используя доступный транспорт.
     * Транспорт – это один из механизмов для взаимодействия с Агентом веб-доступа. Например, NPAPI-транспорт или HTTP-транспорт.
     *
     * @method transport#transmitRequest
     * @param  {string} requestName Имя запроса
     * @param  {string} pluginName Имя плагина Агента, к которому идет обращение.
     * Для базовых вызовов к ядру Веб-агента передается пустая строка
     * @param  {Object} params Параметры запроса
     * @param  {Object} extraParams Дополнительные параметры запроса (например, timeout)
     * @returns {Object} Результат запроса.
     * @since 5.1.0.1500
     */
    transmitRequest: function (requestName, pluginName, params, extraParams) {
      return this.getTransport().transmitRequest(requestName, pluginName, params, extraParams);
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  global.agentCore.transport = transport;

})(window);